@if (!isIframe && !isLoading) {
<router-outlet></router-outlet>
}

@if (!isIframe && isInitializing) {
<div class="startup-loader" role="status" aria-label="Loading">
  <daui-waiting-indicator class="loader" aria-hidden="true"></daui-waiting-indicator>
</div>
}

@if (isLoading && !isInitializing) {
<app-header></app-header>
<div class="content-loader">
  <daui-waiting-indicator class="loader"></daui-waiting-indicator>
</div>
<app-footer-actions></app-footer-actions>
}

<app-idling [idle]="appIdle"> </app-idling>